module.exports = __webpack_public_path__ + "static/media/handrail-round.bd5267f4.jpg";